import { apiRequest } from './client';
import type {
  CreateUserInput,
  ResetPasswordResponse,
  UpdateUserInput,
  UserResponse,
  UsersResponse,
  UserStoresResponse,
} from '../types/users';

export function getUsers(): Promise<UsersResponse> {
  return apiRequest<UsersResponse>('/api/users');
}

export function createUser(input: CreateUserInput): Promise<UserResponse> {
  return apiRequest<UserResponse>('/api/users', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function updateUser(
  userId: string,
  input: UpdateUserInput,
): Promise<UserResponse> {
  return apiRequest<UserResponse>(`/api/users/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export function setUserActive(
  userId: string,
  isActive: boolean,
): Promise<UserResponse> {
  return apiRequest<UserResponse>(`/api/users/${userId}/activate`, {
    method: 'PATCH',
    body: JSON.stringify({ isActive }),
  });
}

export function resetUserPassword(
  userId: string,
  password?: string,
): Promise<ResetPasswordResponse> {
  return apiRequest<ResetPasswordResponse>(`/api/users/${userId}/reset-password`, {
    method: 'POST',
    body: JSON.stringify(password ? { password } : {}),
  });
}

export function getUserStores(userId: string): Promise<UserStoresResponse> {
  return apiRequest<UserStoresResponse>(`/api/users/${userId}/stores`);
}

export function assignUserStores(
  userId: string,
  storeIds: string[],
): Promise<UserStoresResponse> {
  return apiRequest<UserStoresResponse>(`/api/users/${userId}/stores`, {
    method: 'POST',
    body: JSON.stringify({ storeIds }),
  });
}
